export enum SystemConfigGroupEn {
  ERP = 'ERP'
}

export enum SystemConfigERPKeyEn {
  InvoiceGRPORDayGap = 'InvoiceGRPORDayGap'
}
